// @ts-check

const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

export const formatDay = (iso) => {
  const [year, month, day] = iso.split('-').map(Number);
  return `${day} ${MONTHS[month - 1]} ${year}`;
};

/** "26 Sep 2026" for a one-day event, "26 Sep 2026 to 2 Oct 2026" for a range. */
export function formatEventDates({ starts_on: start, ends_on: end }) {
  return end && end !== start ? `${formatDay(start)} to ${formatDay(end)}` : formatDay(start);
}

/**
 * The event the sale form should start on. The one running today if there is exactly one; else the
 * last one used, if it is still a sensible choice; else nothing, so the person picks. Dates are
 * YYYY-MM-DD strings, which compare correctly as text.
 * @param {Array<{id: string, starts_on: string, ends_on: string | null}>} events
 * @param {string} today YYYY-MM-DD in India
 * @param {string} lastEventId
 */
export function pickDefaultEvent(events, today, lastEventId) {
  const running = events.filter((e) => e.starts_on <= today && today <= (e.ends_on || e.starts_on));
  if (running.length === 1) return running[0].id;
  const pool = running.length > 0 ? running : events;
  return pool.some((e) => e.id === lastEventId) ? lastEventId : '';
}

/** Today's date in India as YYYY-MM-DD, whatever timezone this browser is in. */
export const todayInIndia = (now = new Date()) => now.toLocaleDateString('en-CA', { timeZone: 'Asia/Kolkata' });
